import { Injectable, TemplateRef } from "@angular/core";
import { UserService } from "./user.service";
import { AdvertisementService } from "./advertisement.service";
import { ErrorSheetComponent } from "../Messages/error-sheet/error-sheet.component";
import { MatBottomSheet, MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material";
import { InformationSheetComponent } from "../Messages/information-sheet/information-sheet.component";
import { WarningSheetComponent } from "../Messages/warning-sheet/warning-sheet.component";
import { Router } from "@angular/router";
import { DialogLoginComponent } from "../Dialogs/dialog.login/dialog.login.component";
import { EnterDialogComponent } from "../Dialogs/enter-dialog/enter-dialog.component";
import { LoggerMethod } from "../Logger/Logger";
import { getUserTokenFieldSchema } from "../api/AuthHeaders";
import { ComponentType } from "@angular/cdk/portal";
import { ThxDialogComponent } from "../Dialogs/thx-dialog/thx-dialog.component";
import { ThxLogoutDialogComponent } from "../Dialogs/thx-logout-dialog/thx-logout-dialog.component";
import { Subject } from "rxjs";
import { CaptchaService } from "./captcha.service";
import { CookieService } from "ngx-cookie-service";
import { CompareVersionsComponent } from "../Cms/compare-versions/compare-versions.component";
import { CustomEmojiService } from "./emoji.service";
import { ConfirmationResult, ConfirmationSheetComponent } from "../Messages/confirm-sheet/confirmation-sheet.component";
import { BehaviorSubject } from 'rxjs';
import { DataOptions } from "@agm/core/services/google-maps-types";

@Injectable({
  providedIn: "root"
})
export class MainService {

  //app extra settings
  public enableSubscription:boolean = false;
  public enableCompareVersion:boolean = false;
  public enableLetOurPros:boolean = false;
  public enableAdvertiseWithUs:boolean = false;
  public enablePhoneRegConfirm:boolean = false;
  

  private _disclaimerIsReady:boolean = false;
  private _aplicationIsReady:boolean = false;

  public get disclaimerIsReady(): boolean{
    return this._disclaimerIsReady
  }
  public set disclaimerIsReady(val:boolean){
    this._disclaimerIsReady = val;
    this.hideLoader();
  }
  public get aplicationIsReady(): boolean{
    return this._aplicationIsReady;
  }
  public set aplicationIsReady(val:boolean){
    this._aplicationIsReady = val;
    this.hideLoader();
  }

  public hideLoader(force = false){
    if(this.disclaimerIsReady && this.aplicationIsReady || force){
      document.body.classList.remove("js-loader-active");
      const loaderBody = document.getElementById("loader_body");
      if(loaderBody) loaderBody.classList.add("hidden");
    }
  }

  public showLoader(){
    document.body.classList.add("js-loader-active");
    const loaderBody = document.getElementById("loader_body");
    if(loaderBody) loaderBody.classList.remove("hidden");
  }

  public showStartVideo = true;

  private _progressCounter: number = 0;

  private _citiesFinished: boolean = false;
  public get citiesFinished(): boolean {
    return this._citiesFinished;
  }
  public set citiesFinished(value: boolean) {
    this._citiesFinished = value;
  }

  public get progress() {
    return this._progressCounter > 0;
  }

  public set progress(value: boolean) {
    if (value) {
      this._progressCounter++;
    } else {
      this._progressCounter--;
    }
    this._progressCounter = this._progressCounter < 0 ? 0 : this._progressCounter;
  }

  private _over18Key = "Over18Years";
  private _isOver18 = false;

  public over18Change: Subject<boolean> = new Subject<boolean>();

  public get Over18Years(): boolean {
    if (this.userService.isAuthenticated()) {
      return true;
    }

    if(this._isOver18){
      return true;
    }

    if (!this.cookieService.check(this._over18Key)) {
      return false;
    }

    return this.cookieService.get(this._over18Key) === 'true';

    //if (!sessionStorage.getItem(this._over18Key)) {
    //    return false;
    //}

    //return sessionStorage.getItem(this._over18Key) === "true";
  }

  public set Over18Years(v: boolean) {
    this.over18Change.next(v);
    this._isOver18 = v;
    this.cookieService.set(this._over18Key, v.toString(), 365);
    //sessionStorage.setItem(this._over18Key, v.toString());
  }

  private _selectedSearchParams;

  public get selectedSearchParams(){
    return this._selectedSearchParams.value;
  }

  public set selectedSearchParams(formParams){
    this._selectedSearchParams = formParams;
  }

  public changeSearchData: Subject<{ type: string; value: any }> = new Subject<{ type: string; value: any }>();

  public EnterDialogShown: boolean = false;

  private _pageName: string = "";

  public get pageName(): string {
    return this._pageName;
  }

  public set pageName(name: string){
    this._pageName = name;
    this.observablePageName.next(name);
  }

  public observablePageName;

  constructor(public emojiService: CustomEmojiService, public captchaService: CaptchaService, public userService: UserService, public cookieService: CookieService, public advService: AdvertisementService, private bottomSheet: MatBottomSheet, public dialog: MatDialog, public route: Router) {
    this.userService.services = this;
    this.advService.services = this;
    this.captchaService.obtainCaptchaSiteKeyFromServer();
    this.route.onSameUrlNavigation = "reload";

    this.observablePageName= new BehaviorSubject(this._pageName);
  }

  @LoggerMethod()
  showError(message: string) {
    return this.bottomSheet.open(ErrorSheetComponent, {
      data: { message: message }
    });
  }

  @LoggerMethod()
  showInformation(message: string) {
    return this.bottomSheet.open(InformationSheetComponent, {
      data: { message: message }
    });
  }

  @LoggerMethod()
  showWarning(message: string) {
    return this.bottomSheet.open(WarningSheetComponent, {
      data: { message: message }
    });
  }

  @LoggerMethod()
  showDialog<T, D = any, R = any>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig<D>): Promise<MatDialogRef<T, R>> {
    return new Promise<MatDialogRef<T, R>>((rs, rj) => {
      const dialogRef = this.dialog.open(componentOrTemplateRef, config);
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          rs(result);
        } else {
          rj();
        }
      });
    });
  }

  handleShowUpgradeToPremium() {

    if (!this.cookieService.check("logging_count")) {
      this.cookieService.set("logging_count", "1")
    } else {
      const loggingCount = parseInt(this.cookieService.get("logging_count"));

      if (loggingCount % 3 == 0 && !this.userService.isDemo() && !this.userService.isPremium() && !this.userService.isAdmin()) {
        let item = this.dialog.open(CompareVersionsComponent, {
          width: "80%",
          height: "762px",
          panelClass: "CompareVersionsComponent-panel",
          data: {
            isPopup: true
          }
        });
        item.componentInstance.isPopup = true;
      }

      this.cookieService.set("logging_count", (loggingCount + 1).toString())
    }

  }


  public showConfirm(messageString: string | undefined = undefined, width: string | undefined = undefined): Promise<ConfirmationResult> {
    if (!messageString) {
      messageString = "Are you sure?"
    }
    return new Promise<ConfirmationResult>((rs, rj) => {
      const dialogRef = this.dialog.open(ConfirmationSheetComponent, {
        width: !width ? "40%" : width,
        data: { message: messageString }
      });

      dialogRef.afterClosed().subscribe((res) => {
        rs(res)
      })

    })
  }

  @LoggerMethod()
  showLogin(url: string | undefined = undefined, additionalLoginTitle: string | undefined = undefined) {
    if (this.userService.isAuthenticated()) {
      return;
    } else {
      const dialogRef = this.dialog.open(DialogLoginComponent, {
        width: "400px",
        data: {
          additionalLoginTitle: additionalLoginTitle,
          email: localStorage.getItem("email"),
          password: "",
          rememberme: true,
          url: url
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result && result != "") {
          this.userService
            .login(result.email, result.password, result.rememberme, url)
            .then(r => {



              this.handleShowUpgradeToPremium();

              if (this.route.url == "/register") {
                if (url) this.route.navigate(["main"]);
              } else {
                if (url) this.route.navigate([url]);
              }

              this.advService.searchDataUserAdv.currentSearchRule.userId = this.userService.getUserId();
              this.advService.searchActionForUser();


            })
            .catch(e => {
              this.showError(e)
                .afterDismissed()
                .subscribe(() => {
                  this.showLogin(url);
                });
            });
        }
      });
    }
  }


  public enterDialogRef: MatDialogRef<EnterDialogComponent>; 

  @LoggerMethod()
  showEnterDialog(url: string | undefined = undefined) {
    if (this.userService.isAuthenticated() || this.EnterDialogShown) {
      return;
    } else {
      this.EnterDialogShown = true;
      this.enterDialogRef = this.dialog.open(EnterDialogComponent, {
        autoFocus: true,
        closeOnNavigation: false,
        disableClose: true,
        hasBackdrop: true,
        backdropClass: "enter-backdrop",
        data: {}
      });

      this.enterDialogRef.afterClosed().subscribe(result => {
        if (result == false) {
          window.location.href = "http://google.com";
        }
      });
    }
  }

  showThxLogoutDialog(url: string | undefined = undefined) {
    const dialogRef = this.dialog.open(ThxLogoutDialogComponent, {
      autoFocus: true,
      hasBackdrop: true,
      disableClose: true,
      //backdropClass: "thx-backdrop", // cdk-overlay-dark-backdrop
      data: {}
    })
  }

  showThxDialog(url: string | undefined = undefined) {
    const dialogRef = this.dialog.open(ThxDialogComponent, {
      autoFocus: true,
      //  closeOnNavigation: false,
      // disableClose: true,
      hasBackdrop: true,
      backdropClass: "thx-backdrop",
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (url != "") {
        this.route.navigate([url]);
      } else {
        this.route.navigate([""]);
      }
    });
  }

  getGoogleApiKey() {
    return getUserTokenFieldSchema("userdata");
  }
}
